import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { Form } from '../../../../Layout';

import { StyledRequiredDocumentSelectDrawer } from '../Drawers.styled';

export const StyledEmploymentInfoDrawer = styled(
  StyledRequiredDocumentSelectDrawer,
)({});

export const EmployerFormContainer = styled(Form)(() => ({
  margin: `0 auto`,
  overflow: 'auto',
}));

export const SelfEmployedFormContainer = styled(Form)(() => ({
  margin: `0 auto`,
  overflow: 'auto',
}));

export const QuestionLabel = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  marginTop: theme.spacing(1),
}));
